var map = {
	"./ai.svg": 4455,
	"./customers.svg": 2956,
	"./kas-olcum.svg": 1493,
	"./kasolcum.svg": 6090,
	"./mode.svg": 4604,
	"./muhasebe.svg": 3269,
	"./ok.svg": 1015,
	"./randevu-takip.svg": 5998,
	"./renk-secim.svg": 809,
	"./secure1.svg": 3571,
	"./secure2.svg": 4176,
	"./secure3.svg": 5297,
	"./secure4.svg": 7918,
	"./settings.svg": 9002,
	"./stats.svg": 8010
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2881;